/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum TaskStatusType {
  created = "created",
  accepted = "accepted",
  rejected = "rejected",
  in_transit = "in_transit",
  in_transit_returning = "in_transit_returning",
  completed = "completed",
  cancelled = "cancelled",
  closed = "closed",
  partially_closed = "partially_closed",
}
